import { render, staticRenderFns } from "./VolumeManager.vue?vue&type=template&id=f0f2574a&"
import script from "./VolumeManager.vue?vue&type=script&lang=ts&"
export * from "./VolumeManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports